export const restEdge = {
    logProof: args => `/log-proof/${args}`,
    busRoutes: `/routesWithGeneric/`,
    getOneRoute: args => `/route/${args}`,
    updateRoute: args => `/route/${args}`,
    duplicateRoute: args => `/routes/${args}/duplicate/`,
    deleteRoute: args => `/routes/${args}/delete/`,
    busPlacement: `/generics/`,
    getOneBusPlacement: args => `/generic/${args}`,
    updatePlacement: args => `/generic/${args}`,
    duplicatePlacement: args => `/generics/${args}/duplicate/`,
    deletePlacement: args => `/generics/${args}/delete/`,
    formGeneric: `/form/generic/`,
    createGeneric: `/generics/create/`,
    createBrand: `/form/brand/`,
    createInterest: `/form/interest/`,
    createCategory: `/form/category/`,
    createVehicle: `/form/vehicle/`,
    createRoute: `/routes/`,
    uploadFile: `/form/upload-content/`,
    getUserEmail: `/user-email/`,
    getFormRoute: `/form/route/`,
    busDiscoveryResult: `/routes/discovery`,
    busDiscoveryResultFilter: `/filter/discovery`,
    busDiscoveryDetail: args => `/routes/discovery/${args}`,
    busDiscoveryAddCampaign: `/campaign`,
    getCampaignOne: args => `/campaign/${args}`,
    editBusCampaign: args => `/campaign/edit/${args}`,
    getFormBillboardLocationdata: `/billboard/location-filter`,
    getFormBillboardPlacementdata: `/billboard/placement-filter`,
    createBillboardLocation: `/billboard/location/create`,
    duplicateBillboardLocation: args => `/billboard/location/${args}/duplicate`,
    editBillboardLocation: args => `/billboard/location/${args}/edit`,
    deleteBillboardLocation: args => `/billboard/location/${args}/delete`,
    getBillboardLocationById: args => `/billboard/location/${args}`,
    getBillboardLocation: `/billboard/location/`,
    createBillboardPlacement: `/billboard/placement/create`,
    duplicateBillboardPlacement: args => `/billboard/placement/${args}/duplicate`,
    editBillboardPlacement: args => `/billboard/placement/${args}/edit`,
    deleteBillboardPlacement: args => `/billboard/placement/${args}/delete`,
    getBillboardPlacementById: args => `/billboard/placement/${args}`,
    getBillboardPlacement: `/billboard/placement`,
    uploadBillboardContent: `/billboard/upload-content`,
    uploadBillboardLocationContent: `/billboard/location/upload-content`,
    adminAirlineMedia: `/airlines/media`,
    adminAirlineGetMedia: args => `/airlines/media/${args}`,
    adminAirlineCreateMedia: `/airlines/media/create`,
    adminAirlineEditMedia: args => `/airlines/media/${args}/edit`,
    adminAirlineMediaDelete: args => `/airlines/media/${args}/delete`,
    adminAirlineMediaDuplicate: args => `/airlines/media/${args}/duplicate`,
    adminAirlineMediaList: `/airlines/mediaList`,
    adminAirlinePlacement: `/airlines/placement`,
    adminAirlineGetPlacement: args => `/airlines/placement/${args}`,
    adminAirlineEditPlacement: args => `/airlines/placement/${args}/edit`,
    adminAirlineCreatePlacement: `/airlines/placement/create`,
    adminAirlinePlacementDelete: args => `/airlines/placement/${args}/delete`,
    adminAirlinePlacementDuplicate: args => `/airlines/placement/${args}/duplicate`,
    adminAirlineGetProfile: args => `/airlines/profile/${args}`,
    adminAirlineEditProfile: args => `/airlines/profile/${args}/edit`,
    adminAirlineCreateProfile: `/airlines/profile/create`,
    adminAirlineContent: `/airlines/upload-content`,
    airlineBrand: `/brand`,
    airlinesFilter: `/airlines/filter`,
    airlineNewBrand: `/brand/create`,
    airlineNewRegion: `/airlines/region/create/`,
    airlineMediaFilter: `/airlines/filter-media/`,
    airlineMediaFilterListing: `/airlines/filter-media-listing/`,
    airlineDeleteRoute: args => `/airlines/estimated-route/${args}/delete`,
    airlineDeleteImage: args => `/airlines/content/${args}/delete`,
    airlinesPricelist: `/airlines/placement`,
    airlinesPlacement: args => `/airlines/placement/${args}`,
    airlinesLineItem: `/airlines/lineitem`,
    getAirlinesPlacement: `/airlines/placement`,
    outdoorPricelist: `/outdoor/pricelist`,
    outdoorLineItem: `/outdoor/lineitem`,
    outdoorPricelistDetail: args => `/outdoor/pricelist/${args}`,
    outdoorPricelistFilter: `/outdoor/pricelist/filter`,
    outdoorPlacementDetail: args => `/billboard/placement/${args}`,
    getOutdoorPlacement: `/outdoor/placement`,
    // busPricelist: `/outdoor/pricelist`,
    // busPricelistDetail: args => `/outdoor/pricelist/${args}`,
    // busPricelistFilter: `/outdoor/pricelist/filter`,
    // busPlacementDetail: args => `/billboard/placement/${args}`,
    // getBusPlacement: `/outdoor/placement`,
    getLifestylePlacement: `/lifestyle/placement`,
    lifestylePricelist: `/lifestyle/pricelist`,
    lifestylePricelistDetail: args => `/lifestyle/pricelist/${args}`,
    lifestylePricelistFilter: `/lifestyle/pricelist/filter`,
    lifestyleLineItem: `/lifestyle/lineitem`,
    createCampaignChannel: `/campaignChannel/create`,
    getAllCampaignChannel: `/campaignChannel/`,
    patchCampaignChannel: args => `campaignChannel/${args}/add/`,
    getCampaignChannel: args => `/campaignChannel/${args}`,
    editCampaignChannel: args => `/campaignChannel/${args}/edit`,
    draftCampaignChannel: `/campaignChannel/`,
    deleteDraftCampaignChannel: args => `campaignChannel/${args}/delete`,
    duplicateDraftCampaignChannel: args => `/campaignChannel/${args}/duplicate/`,
    editItemPrice: args => `/campaignChannel/${args}/editprice`,
    quotationList: `/quotations`,
    createQuotation: `/quotation`,
    getOneQuotation: args => `/quotation/${args}`,
    editQuotation: args => `/quotation/${args}/edit`,
    getClientProfile: `/clients-profile`,
    getOneClientProfile: args => `/client-profile/${args}`,
    createClientProfile: `/client-profile`,
    editClientProfile: args => `/client-profile/${args}/edit`,
    busMonitoringStatus: args => `/monitoring/campaign/${args}/vehicle/status`,
    busMonitoringDetail: args => `/monitoring/campaign/${args}/vehicle/detail`,
    busMonitoringPosition: args => `/monitoring/campaign/${args}/vehicle/position`,
    busMeasurementSummary: args => `/measurement/${args}/campaign_summary`,
    busRouteSummary: args => `/measurement/${args}/route_summary`,
    busCoverageSummary: args => `/measurement/${args}/coverage_summary`,
    busVehicleSummary: args => `/measurement/${args}/vehicle_summary`,
    busPricelist: `/bus/pricelist`,
    busPricelistDetail: args => `/bus/pricelist/${args}`,
    busPricelistFilter: `/bus/pricelist/filter`,
    dashboardMediaOwnerList:`/m-owner-dashboard/campaign`,
    filterMediaOwnerList:`/m-owner-dashboard/campaign/filter`,
    // busPlacementDetail: args => `/bus/placement/${args}`,
    // getBusPlacement: `/bus/placement`,
    listBillboardCode: `/billboard/codes/`,
    listBillboardType: `/billboard/types/`,
    listCity: `/street/cities/`,
    listStreet: `/street/`,
    listBillboard: `/billboard/`,
    downloadBillboard:  args => `/billboard/download/${args}`,
    billboardCampaign: `/billboard-campaign-list/`,
    billboardCampaignDetail: args => `/billboard-campaign/${args}`,
    createBillboardCampaign: `/billboard-campaign/`,
    deleteBillboardCampaign: args => `/billboard-campaign/${args}/delete`,
    updateBillboardCampaign: args => `/billboard-campaign/${args}/edit`
}

export default {
    restEdge
}
